<div class='container'>
  <div class='pt-4'>
    <mat-form-field class='w-100'>

      <mat-label>Filter</mat-label>
      <input matInput (keyup)='updateSearchTerm($event)' placeholder='Filter' #input/>

    </mat-form-field>
    <div class='d-flex align-items-center'>
      <input type='checkbox' id='activeFilter' class='mr-2' (change)='filterActive()'/>
            <label class='mb-0' for='activeFilter'>Show active organizations only</label>

    </div>

    <div *ngFor='let i of [].constructor(20)' [hidden]='!loading' class='list-container row my-2'>
      <div class='col-8 row'>
<!--        <div class='col-4'>-->
<!--          <small class='mb-1'>ORG ID</small>-->
<!--          <div>-->
<!--            <ngx-skeleton-loader count='1' [theme]="{-->
<!--          'width': '75%'-->
<!--        }"></ngx-skeleton-loader>-->
<!--          </div>-->
<!--        </div>-->
        <div class='col-4'>
          <small class='mb-1 mt-2'>ORG NAME</small>
          <div>

            <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }"></ngx-skeleton-loader>
          </div>
        </div>
        <div class='col-4'>
          <small class='mb-1 mt-2'>NUMBER OF USERS</small>
          <div>

            <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
      <div class='col-4 d-flex flex-column'>
        <div>

          <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }"></ngx-skeleton-loader>
        </div>
        <div>

          <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }"></ngx-skeleton-loader>
        </div>
      </div>
    </div>


    <div (click)='navigateToOrg(org)' *ngFor='let org of orgListDisplayed' [hidden]='showActiveOnly && !org.active' class='list-container row my-2 pointer-cursor'>
      <div class='col-8 row'>
        <div class='col-4'>
          <small class='mb-1 mt-2'>ORG NAME</small>
          <div>{{org.name}}</div>
        </div>
        <div class='col-4'>
          <small class='mb-1 mt-2'>NUMBER OF USERS</small>
          <div>{{org.numberOfUsers}}</div>
        </div>
      </div>
      <div class='col-4 d-flex flex-column'>
        <button class='btn btn-link' (click)='editTestTypes(org.id)'><small>Edit Test Types</small></button>

      </div>
    </div>

  </div>
</div>
